export default __webpack_public_path__ + "static/f27-eafd53315f8e6f7a2d99267ea965e3dc.svg";